var _style, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1668.56 1221.19"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".twitter_svg__st0{fill:#000;stroke:#fff;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7 0 0 1.7 -600 -400)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 834.28,
    cy: 610.6,
    r: 481.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "twitter_svg__layer1",
    transform: "translate(52.39 -25.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter_svg__path1009",
    d: "m485.39 356.79 230.07 307.62-231.52 250.11h52.11l202.7-218.98 163.77 218.98h177.32L836.82 589.6l215.5-232.81h-52.11L813.54 558.46 662.71 356.79H485.39zm76.63 38.38h81.46l359.72 480.97h-81.46L562.02 395.17z",
    style: {
      fill: "#fff"
    }
  }))));
};
export default SvgTwitter;